import { Component, OnChanges, Input, EventEmitter, Output } from '@angular/core';
import { ErrorHandlerService } from '../errorhandler/gpiserror-handler.service';
import { PackageInstructionMHBE, PackageInstructionAdditionalMHBE, PackageInstructionLevelInfo } from './shared/packaging-instruction-material.model';
import { PartListBE } from '../partsupplierpru/shared/partsupplierpru.model';
import { PArray } from '../shared/packit-array';
import { PkgInstrLevelInfo, PkgInstrLevelAdditionalMaterialBE, PkgInstrLevelMaterialBE } from './shared/packaging-instruction.model';
import { ChineseChangeValueService } from '../chinese-change-value.service';
declare var jQuery: any;

@Component({
    moduleId: module.id,
    selector: 'list-packaging-instruction-material',
    templateUrl: 'list-packaging-instruction-material.html',
    providers: [ChineseChangeValueService],
    styleUrls: ['packaging-instruction-material.css']
})
export class ListPackagingInstructionMaterialComponent implements OnChanges {
    @Input() disabled = true;
    @Input() levelInfo: PkgInstrLevelInfo;
    @Input() consistingParts: PartListBE[] = null;
    @Output() onDataChangedExecuteCommand: EventEmitter<boolean> = new EventEmitter<boolean>();

    isDisabled = true;
    showSpinner: boolean;
    consistingPartsDropDownTitle = '';

    constructor(private errHandler: ErrorHandlerService,public ChineseChangeValueService:ChineseChangeValueService) { }

    ngOnChanges() {
        this.consistingPartsDropDownTitle = (this.consistingParts == null || this.consistingParts.length === 0)
            ? 'No composition parts available for selection but freetext can be entered manually'
            : 'Select consisting part';

        this.isDisabled = this.disabled;
        this.setLevelNumbering();
    }

    setLevelNumbering() {
        const levelNumberingMain: string = this.levelInfo.Level === 99
            ? '4'
            : this.levelInfo.Level.toString();
        this.levelInfo.LevelSubNumbering = `${levelNumberingMain}.1`;

        let currentSubLevel = 2;
        for (let i = 0; i < this.levelInfo.AdditionalMaterials.length; i++) {
            this.levelInfo.AdditionalMaterials[i].LevelSubNumbering = `${levelNumberingMain}.${currentSubLevel.toString()}`;
            currentSubLevel++;
        }
    }

    selectAddMtrlPart(part: PartListBE, material: PackageInstructionAdditionalMHBE) {
        material.PartText = part.PartNo;
    }

    selectMtrlPart(part: PartListBE, material: PackageInstructionMHBE) {
        material.PartText = part.PartNo;
    }

    isLevelData(): boolean {
        return this.isCodeMaterialData() || this.isAdditionalMaterialData();
    }

    isAdditionalMaterialData(): boolean {
        return this.levelInfo.AdditionalMaterials.length > 0;
    }

    isCodeMaterialData(): boolean {
        return this.levelInfo.CodeMaterials.length > 0;
    }

    hasNoConsistingParts(): boolean {
        return this.isDisabled || this.consistingParts == null || this.consistingParts.length === 0;
    }

    onDataChanged() {
        this.onDataChangedExecuteCommand.emit(true);
    }
}




// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/packaging-instruction/list-packaging-instruction-material.component.ts